import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=6c05158b"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductInfo: require('/opt/build/repo/components/product/Info.vue').default,ProductPrice: require('/opt/build/repo/components/product/Price.vue').default,EshopCartForm: require('/opt/build/repo/node_modules/@evince/eshop/lib/packages/CartForm.vue').default,ProductWarranty: require('/opt/build/repo/components/product/Warranty.vue').default,ProductForm: require('/opt/build/repo/components/product/Form.vue').default,ProductAttributes: require('/opt/build/repo/components/product/Attributes.vue').default,ProductCompatibility: require('/opt/build/repo/components/product/Compatibility.vue').default,ProductBrand: require('/opt/build/repo/components/product/Brand.vue').default,ProductCountry: require('/opt/build/repo/components/product/Country.vue').default})
